import CitySEOHead from "@/components/feature/CitySEOHead";
import MinnetonkaHeroSection from "./components/HeroSection";
import MinnetonkaStickyNav from "./components/StickyNav";
import MinnetonkaProcessingTimeSection from "./components/ProcessingTimeSection";
import MinnetonkaServicesSection from "./components/ServicesSection";
import MinnetonkaLocalAreaSection from "./components/LocalAreaSection";
import MinnetonkaTravelTimingSection from "./components/TravelTimingSection";
import MinnetonkaDestinationsSection from "./components/DestinationsSection";
import MinnetonkaTestimonialsSection from "./components/TestimonialsSection";
import MinnetonkaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MinnetonkaComparisonSection from "./components/ComparisonSection";
import MinnetonkaMistakesSection from "./components/MistakesSection";
import MinnetonkaHowItWorksSection from "./components/HowItWorksSection";
import MinnetonkaFAQSection from "./components/FAQSection";
import MinnetonkaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MinnetonkaFinalCTA from "./components/FinalCTA";
import { faqs } from "./components/FAQSection";

export default function MinnetonkaPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Minnetonka"
        state="Minnesota"
        stateAbbr="MN"
        route="/cities/minnetonka"
        title="Emergency Passport Minnetonka, MN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Minnetonka, MN — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving UnitedHealth Group executives, Lake Minnetonka families, and all of western Hennepin County."
        keywords="expedited passport Minnetonka MN, emergency passport Minnetonka, passport renewal Hennepin County"
        geoPlacename="Minnetonka, Minnesota"
        geoPosition="44.9213;-93.4683"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Minnesota"
        statePageRoute="/states/minnesota"
      />
      <MinnetonkaHeroSection />
      <MinnetonkaStickyNav />
      <MinnetonkaProcessingTimeSection />
      <MinnetonkaLocalAreaSection />
      <MinnetonkaServicesSection />
      <MinnetonkaTravelTimingSection />
      <MinnetonkaDestinationsSection />
      <MinnetonkaTestimonialsSection />
      <MinnetonkaAcceptanceFacilitiesSection />
      <MinnetonkaComparisonSection />
      <MinnetonkaMistakesSection />
      <MinnetonkaHowItWorksSection />
      <MinnetonkaFAQSection />
      <MinnetonkaHelpfulResourcesSection />
      <MinnetonkaFinalCTA />
    </div>
  );
}